module.exports = __webpack_public_path__ + "img/f18.51616442.jpg";